'use client';

import { Card, CardContent } from '@/components/ui/card';
import Image from 'next/image';

type Slide = {
    src: string;
};

type DesktopSlideProps = {
    slide: Slide;
    index: number;
    width: number;
    height: number;
    setRatioAt: (idx: number, ratio: number) => void;
};

export function DesktopSlide({
    slide,
    index,
    width,
    height,
    setRatioAt,
}: DesktopSlideProps) {
    return (
        <div
            className="relative hidden lg:block"
            style={{
                width,
                height,
            }}
        >
            <Card className="h-full w-full border-0 bg-transparent p-0 shadow-none">
                <CardContent className="relative h-full w-full p-0">
                    <Image
                        src={slide.src}
                        alt={`Slide ${index + 1}`}
                        fill
                        className="bg-beige h-full w-full rounded-lg object-cover object-center"
                        onLoadingComplete={({
                            naturalWidth,
                            naturalHeight,
                        }) => {
                            if (naturalHeight > 0) {
                                setRatioAt(index, naturalWidth / naturalHeight);
                            }
                        }}
                        sizes={`${width}px`}
                        priority={true}
                    />
                </CardContent>
            </Card>
        </div>
    );
}
